import React, { useCallback, useState } from "react";
import { Accordion } from "@gcs/design-system/react";

import Button from "../Button/Button";

import useWindowSize from "hooks/useWindowSize";

import { ReactComponent as DownloadIcon } from "assets/svgs/download-icon.svg";

import * as S from "./Tabs.Style";

const Tabs = ({ defaultIndex, tabs }) => {
  const [currentTab, setCurrentTab] = useState(defaultIndex ?? 0);
  const { width } = useWindowSize();
  const isMobile = width && width <= 992;

  const handleClickTabsTrigger = useCallback((tabIndex) => {
    setCurrentTab(tabIndex);
  }, []);

  const handleClickLink = useCallback((url) => {
    if (!url) {
      return;
    }

    window.open(url, "_blank");
  }, []);

  return (
    <S.TabsContainer>
      {!isMobile && (
        <S.TabsList>
          {Array?.isArray(tabs) &&
            tabs.map((tabItem, index) => (
              <S.TabsTrigger
                id={`tab-${index}-header`}
                key={`tab-${index}-header`}
                type="button"
                $isActiveTab={currentTab === index}
                onClick={() => handleClickTabsTrigger(index)}
              >
                {tabItem?.title}
              </S.TabsTrigger>
            ))}
        </S.TabsList>
      )}

      {!isMobile ? (
        tabs?.[currentTab]?.content && tabs[currentTab].content
      ) : (
        <Accordion>
          {tabs.map((tab) => (
            <S.TabsAccordion title={tab.title} key={tab.title}>
              <S.TabsAccordionContent>
                {tab?.description ? tab.description : null}

                {Array.isArray(tab.links)
                  ? tab?.links?.map((linkItem, index) => (
                      <Button
                        key={index}
                        type="button"
                        rel="noreferrer"
                        onClick={() => handleClickLink(linkItem?.href)}
                      >
                        <DownloadIcon /> <span>{linkItem?.label}</span>
                      </Button>
                    ))
                  : null}
              </S.TabsAccordionContent>
            </S.TabsAccordion>
          ))}
        </Accordion>
      )}
    </S.TabsContainer>
  );
};

export default Tabs;
